var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 48,
    rx: 6,
    fill: "#0057CC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6874 7H25.7174L34.2182 15.8606V33.0945C34.2182 35.2534 32.4715 37 30.3201 37H15.6874C13.5285 37 11.7819 35.2534 11.7819 33.0945V10.9055C11.7819 8.74662 13.5285 7 15.6874 7Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7099 7V15.7931H34.2182L25.7099 7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1222 29.3836V23.9038H18.4535C19.0308 23.9038 19.488 24.0612 19.8329 24.3836C20.1777 24.6984 20.3501 25.1257 20.3501 25.6579C20.3501 26.1902 20.1777 26.6175 19.8329 26.9323C19.488 27.2546 19.0308 27.4121 18.4535 27.4121H17.524V29.3836H16.1222ZM17.524 26.2202H18.2961C18.506 26.2202 18.6709 26.1752 18.7834 26.0703C18.8958 25.9728 18.9558 25.8379 18.9558 25.658C18.9558 25.4781 18.8958 25.3431 18.7834 25.2457C18.671 25.1407 18.506 25.0958 18.2961 25.0958H17.524V26.2202ZM20.9273 29.3836V23.9038H22.8688C23.2511 23.9038 23.611 23.9563 23.9483 24.0687C24.2856 24.1812 24.593 24.3386 24.8628 24.556C25.1327 24.7659 25.3501 25.0507 25.5075 25.4106C25.6574 25.7704 25.7399 26.1827 25.7399 26.6474C25.7399 27.1047 25.6574 27.517 25.5075 27.8768C25.3501 28.2366 25.1327 28.5215 24.8628 28.7314C24.5929 28.9488 24.2856 29.1062 23.9483 29.2186C23.611 29.3311 23.2511 29.3836 22.8688 29.3836H20.9273ZM22.2991 28.1917H22.7039C22.9213 28.1917 23.1237 28.1692 23.3111 28.1167C23.491 28.0643 23.6634 27.9818 23.8283 27.8693C23.9858 27.7569 24.1132 27.5995 24.2031 27.3896C24.2931 27.1797 24.3381 26.9323 24.3381 26.6474C24.3381 26.3551 24.2931 26.1077 24.2031 25.8978C24.1132 25.688 23.9858 25.5305 23.8283 25.4181C23.6634 25.3056 23.491 25.2232 23.3111 25.1707C23.1237 25.1182 22.9213 25.0957 22.7039 25.0957H22.2991V28.1917ZM26.4445 29.3836V23.9038H30.3426V25.0957H27.8463V25.9728H29.8403V27.1572H27.8463V29.3836H26.4445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFileIcon);
export default __webpack_public_path__ + "static/media/Pdf_File_Icon.b80e066ca5e48c4bbcd5c57c95ae68c2.svg";
export { ForwardRef as ReactComponent };